import { archetypeLightStitchesTheme } from '@leagueplatform/genesis-core';
import { formatThemeForCommons } from './utils/format-theme-for-commons';
import { themeWithGlobalTokens } from '../utils/themeWithGlobalTokens';

export const commonsArchetypeLightTheme = formatThemeForCommons(
  archetypeLightStitchesTheme
);

export const commonsArchetypeLightThemeWithGlobalTokens = themeWithGlobalTokens(
  commonsArchetypeLightTheme
);
